const whiteList = [
    '/login',
    '/logout',
    '/404',
    '/401'
];
export default whiteList;
